// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IPermissionDto } from './IPermissionDto';
import {
    IPermissionDtoFromJSON,
    IPermissionDtoFromJSONTyped,
    IPermissionDtoToJSON,
    IPermissionDtoToJSONTyped,
} from './IPermissionDto';

/**
 * 
 * @export
 * @interface IGroupedPermissionsDto
 */
export interface IGroupedPermissionsDto {
    /**
     * 
     * @type {number}
     * @memberof IGroupedPermissionsDto
     */
    order?: number;
    /**
     * 
     * @type {Array<IPermissionDto>}
     * @memberof IGroupedPermissionsDto
     */
    permissions?: Array<IPermissionDto>;
}

/**
 * Check if a given object implements the IGroupedPermissionsDto interface.
 */
export function instanceOfIGroupedPermissionsDto(value: object): value is IGroupedPermissionsDto {
    return true;
}

export function IGroupedPermissionsDtoFromJSON(json: any): IGroupedPermissionsDto {
    return IGroupedPermissionsDtoFromJSONTyped(json, false);
}

export function IGroupedPermissionsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IGroupedPermissionsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'order': json['order'] == null ? undefined : json['order'],
        'permissions': json['permissions'] == null ? undefined : ((json['permissions'] as Array<any>).map(IPermissionDtoFromJSON)),
    };
}

export function IGroupedPermissionsDtoToJSON(json: any): IGroupedPermissionsDto {
    return IGroupedPermissionsDtoToJSONTyped(json, false);
}

export function IGroupedPermissionsDtoToJSONTyped(value?: IGroupedPermissionsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'order': value['order'],
        'permissions': value['permissions'] == null ? undefined : ((value['permissions'] as Array<any>).map(IPermissionDtoToJSON)),
    };
}

